import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../Tooltip';

function TitleTooltip(props) {
  return /*#__PURE__*/React.createElement(Tooltip, _extends({
    mouseThrough: true,
    mouseEnterDelay: 0
  }, props));
}

TitleTooltip.propTypes = {
  trigger: PropTypes.oneOf(['click', 'hover', 'control']),
  className: PropTypes.string,
  theme: PropTypes.oneOf(['light', 'dark']),
  placement: PropTypes.oneOf(['top', 'topLeft', 'topRight', 'left', 'leftTop', 'leftBottom', 'bottom', 'bottomLeft', 'bottomRight', 'right', 'rightTop', 'rightBottom']),
  title: PropTypes.node,
  children: PropTypes.element.isRequired,
  visibility: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  arrowPointAtCenter: PropTypes.bool
};
TitleTooltip.defaultProps = {
  trigger: 'hover',
  className: '',
  theme: 'dark',
  placement: 'top',
  title: null,
  visibility: true,
  arrowPointAtCenter: false
};
export default TitleTooltip;